import { render } from "./TestTempComponent.vue?vue&type=template&id=c8e4a698"
import script from "./TestTempComponent.vue?vue&type=script&lang=js"
export * from "./TestTempComponent.vue?vue&type=script&lang=js"

import "./TestTempComponent.vue?vue&type=style&index=0&id=c8e4a698&setup=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__